import { useState, useEffect } from 'react';
import { Translate } from 'react-i18nify';
import { configuredMoment as moment } from '../../utils';
import './MaintenanceBanner.scss';

const MaintenanceBanner = ({ startTime }) => {
  const [duration, setDuration] = useState(moment.duration(startTime.diff(moment())));
  const [intervalId, setIntervalId] = useState();

  useEffect(() => {
    if (startTime.isAfter(moment())) {
      const intervalId = setInterval(() => {
        setDuration(moment.duration(startTime.diff(moment())));
      }, 1000);
      setIntervalId(intervalId);
    }

    return () => {
      clearInterval(intervalId);
    };
    // eslint-disable-next-line
  }, []);

  if (duration.asSeconds() <= 0) {
    clearInterval(intervalId);
    return null;
  }

  return (
    <div className="global-banner">
      <Translate value="maintenance_mode.banner" remainingTime={startTime.fromNow(true)} />
    </div>
  );
};

export default MaintenanceBanner;
